import Route from '../services/route'

const routeStore = {
  state: {
    actives: undefined,
    inactives: undefined
  },
  mutations:{
    setActives(state, routes){
      state.actives = routes;
    },
    setInactives(state, routes){
      state.inactives = routes;
    },

    deleteRoute(state, id) {
      
      let idx = state.actives.findIndex(r => {return r.routeId == id});
      
      state.actives.splice(idx, 1);
      //context.commit('setActives', context.state.actives);
    }
  },
  getters:{
    getRouteById: (state, getters) => (routeId, version) => {
      if(state.actives){
        let r = state.actives.find(r => {return r.routeId == routeId && r.version == version});
        if(r) return r;
      }
      if(state.inactives){
        let r = state.inactives.find(r => {return r.routeId == routeId && r.version == version});
        if(r) return r;
      }

      return undefined;
    },

    getRoutesActive(state) {
      return state.actives;
    }
  },
  actions:{
    getRoutes(context, payload){
      let a = Route.getRoute(true, payload).then(r => {
        context.commit('setActives', r);
        return r;
      }).catch(err => {
          context.commit('setActives', []);
      });

      // ROTAS INATIVAS: FORAM COMENTADAS POR NÃO ESTARAM MAIS SENDO UTILIZADAS

      // let i = Route.getRoute(false).then(r => {
      //   context.commit('setInactives', r);
      //   return r;
      // }).catch(err => {
      //   context.commit('setInactives', []);
      // });
      // return Promise.all([a, i]);
      return Promise.all([a]);
    },
    deleteRoute(context, id) {
      
      let idx = context.state.actives.findIndex(r => {return r.routeId == id});
      context.state.actives.slice(idx, 1);
      context.commit('setActives', context.state.actives);
    }
  },

}

export default routeStore;



// WEBPACK FOOTER //
// ./src/store/route.js